// @flow

import { all } from 'redux-saga/effects';
import formSagas from './Form/sagas';

export default function* feedbackSagas(): Generator<*, *, *> {
  // $FlowFixMe
  yield all([formSagas()]);
}



// WEBPACK FOOTER //
// ./app/CaptureFeedback/sagas.js